// Hulk Wishlist Enhancer - Full Inline Version with Stock Fallback
(function () {
  if (!window) return;

  const productCache = {};

  // Fetch product JSON once per handle
  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return productCache[handle];

    const p = fetch(`/products/${handle}/?view=variant_invatory`)
      .then(r => (r.ok ? r.json() : null))
      .catch(() => null);

    productCache[handle] = p;
    return p;
  }

  // Map inventory quantity or available flag to stock text & class
  function getStockInfo(qty, available) {
    // Use qty if defined
    if (qty != null) {
      qty = Number(qty);
      if (isNaN(qty)) return { text: "", className: "" };
      if (qty <= 0) return { text: "Out of Stock", className: "out-of-stock" };
      if (qty <= 10) return { text: "Low Stock", className: "low-stock" };
      return { text: "In Stock", className: "in-stock" };
    }

    // Fallback to available flag
    if (available === true) return { text: "Available", className: "in-stock" };
    if (available === false) return { text: "Unavailable", className: "out-of-stock" };

    return { text: "", className: "" };
  }

  // Format date nicely
  function formatDate(d) {
    if (!d) return "";
    const dt = new Date(d);
    if (isNaN(dt.getTime())) return d;
    return dt.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  }

  // Enhance a single wishlist card
  function enhanceCard(card) {
    if (!card || card.classList.contains("hulk-enhanced")) return;

    const handle = card.getAttribute("data-handle");
    const variantId = card.getAttribute("data-varid");
    if (!handle) return;

    const meta = window.productMetafields?.[handle];
    const content = card.querySelector(".wishlist__product-content");
    if (!content) return;

    fetchProduct(handle).then(product => {
      if (!product) return;
      
        const btnmtc = card.querySelector(".wishlist-btn[data-addmywishlistprotocart]");
        // console.log("btnmtc",btnmtc);
        // console.log("product",product,"variantId",variantId);

        const selectedVariant = product.variants.find(
        variant => variant.id == Number(variantId)
        );

        if (!selectedVariant) return;

        if (!selectedVariant.available) {
        btnmtc.disabled = true;
        btnmtc.textContent = "Ausverkauft";
        btnmtc.setAttribute("aria-disabled", "true");
        } else {
        btnmtc.disabled = false;
        btnmtc.textContent = "In den Warenkorb"; // Change if needed
        btnmtc.removeAttribute("aria-disabled");
        }
    });

    card.classList.add("hulk-enhanced");
  }

  // Enhance all wishlist cards
  function enhanceAll() {
    document.querySelectorAll(".wishlist-card").forEach(enhanceCard);
  }

  // Observe dynamic wishlist additions via AJAX
  function observeWishlist() {
    const container = document.querySelector(".wishlist-grid-view") || document.body;

    const observer = new MutationObserver(() => {
      enhanceAll();
    });

    observer.observe(container, { childList: true, subtree: true });

    // Initial run
    enhanceAll();
  }

  // Run on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeWishlist);
  } else {
    observeWishlist();
  }
})();
